export default __webpack_public_path__ + "static/media/kitchen5-afterA-768w.7a2ff53f.avif";